(function() {
    "use strict";
    
    var formatterRegex = /\{(\d+)(?::[^\}]+)?\}/g;
    String.prototype.format = function() {
        var args = arguments;
        return this.replace(formatterRegex, function(full, value, extra) {
            return String(args[parseInt(value, 10)]);
        });
    };
})();



// WEBPACK FOOTER //
// ./content/js/PrototypeExtensions/String.format.js